import { render, staticRenderFns } from "./jianjie.vue?vue&type=template&id=5fba5236&scoped=true&"
import script from "./jianjie.vue?vue&type=script&lang=js&"
export * from "./jianjie.vue?vue&type=script&lang=js&"
import style0 from "./jianjie.vue?vue&type=style&index=0&id=5fba5236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fba5236",
  null
  
)

export default component.exports